import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ScoreSavedVariationText(
    $savedVariationId: ID!
    $text: String!
    $scoringMethod: ScoringMethodInput
  ) {
    scoreSavedVariationText(
      savedVariationId: $savedVariationId
      text: $text
      scoringMethod: $scoringMethod
    ) {
      score
    }
  }
`;

export const scoreSavedVariationText = ({ variationId, text, scoringMethod }, options) => {
  const variables = {
    savedVariationId: variationId,
    text,
    scoringMethod,
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  }).then(({ data }) => getSingleProp(data));
};
